export const projects: TableModule = {
    name: "projects",
    route: "spa.projects.organisations.projects",
    defaultOrder: {
        column: "created_at",
        direction: "desc"
    },
    routeParams: [{
        param: "organisation",
        prop: "organisation_id"
    }],
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: "reference_number",
            sortable: true,
        },
        {
            name: "order_number",
            sortable: true,
        },
        {
            name: "status",
            sortable: true,
        },
        {
            name: "created_at",
            sortable: true,
        }
    ],
    filters: [
        {
            name: "id",
            column: "projects.id",
            type: "numeric"
        },
        {
            name: "status",
            column: "projects.status",
            type: "select",
            options: [
                {
                    value: "active",
                    label: "projects.statusLabels.active"
                },
                {
                    value: "inactive",
                    label: "projects.statusLabels.inactive"
                }
            ],
            reduced: true
        },
    ],
    quickFilters: [],
    tools: [
        {
            name: "projects.create",
            isCreateAction: true,
            ability: ["create", "projects"]
        },
    ],
}
